import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from './header/header.component';
import { LoaderComponent } from './loader/loader.component';
import { AppRoutingModule } from '../app-routing.module';
import { ErrorModalComponent } from '@shared//modals/error-modal/error-modal.component';
import { ToTopBtnComponent } from './to-top-btn/to-top-btn.component';
import { LeaveModalComponent } from '@shared//modals/leave-modal/leave-modal.component';
import { DeleteModalComponent } from '@shared//modals/delete-modal/delete-modal.component';
import { RetailerSuccessModalComponent } from '@shared//modals/retailer-success-modal/retailer-success-modal.component';
import { RetailerNoSelectModalComponent } from '@shared//modals/retailer-no-select-modal/retailer-no-select-modal.component';
import { RetailerSelectModalComponent } from '@shared//modals/retailer-select-modal/retailer-select-modal.component';
import { SaveWorkModalComponent } from '@shared//modals/save-work-modal/save-work-modal.component';
import { SelectBackgroundModalComponent } from '@shared//modals/select-background-modal/select-background-modal.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ReactiveFormsModule } from '@angular/forms';
import { RotateDeviceModalComponent } from '@shared//modals/rotate-device-modal/rotate-device-modal.component';
import { ArLoadingModalComponent } from '@shared//modals/ar-loading-modal/ar-loading-modal.component';
import { QuizModalComponent } from '@shared//modals/quiz-modal/quiz-modal.component';
import { RetailerInfoModalComponent } from '@shared//modals/retailer-info-modal/retailer-info-modal.component';
import { RetailerInfoPopoverComponent } from '@shared//modals/retailer-info-popover/retailer-info-popover.component';
import { AugmentedRealityComponent } from '@shared/augmented-reality/augmented-reality.component';
import { SaveWorkEmailModalComponent } from '@shared/modals/save-work-email-modal/save-work-email-modal.component';
import { DisabledLinkModalComponent } from '@shared//modals/disabled-link-modal/disabled-link-modal.component';
import { ConfirmModalComponent } from '@shared/modals/confirm-modal/confirm-modal.component';
import { ChangeBackgroundImageModalComponent } from '@shared/modals/change-background-image-modal/change-background-image-modal.component';

import { DirectivesModule } from '@core/directives/directives.module';
import { TaskbarComponent } from '@shared/taskbar/taskbar.component';
import { ArNoBlindsModalComponent } from './modals/ar-no-blinds-modal/ar-no-blinds-modal.component';
import { AnotherDeviceModalComponent } from './modals/another-device-modal/another-device-modal.component';
import { LinkUnavailableModalComponent } from './modals/link-unavailable-modal/link-unavailable-modal.component';
import { CountrySelectorComponent } from '@shared/country-selector/country-selector.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FeedbackFormComponent } from '@shared/feedback-form/feedback-form.component';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { PayDepositModalComponent } from '@shared/modals/pay-deposit-modal/pay-deposit-modal.component';
import { DepositSuccessModalComponent } from '@shared/modals/deposit-success-modal/deposit-success-modal.component';
import { CoreModule } from '@core/core.module';
import {
	NgxStripeElementLoadingTemplateDirective,
	StripeCardComponent,
	StripeCardCvcComponent,
	StripeCardExpiryComponent,
	StripeCardGroupDirective,
	StripeCardNumberComponent,
	StripePaymentRequestButtonComponent,
} from 'ngx-stripe';
import { VerifyEmailModalComponent } from './modals/verify-email-modal/verify-email-modal.component';
import { QuotationMobileModalComponent } from '@shared/modals/quotation-mobile-modal/quotation-mobile-modal.component';
import { MessageBoxComponent } from '@shared/message-box/message-box.component';
import { OrderPlacedModalComponent } from '@shared/modals/order-placed-modal/order-placed-modal.component';
import { EnquiryErrorModalComponent } from './modals/enquiry-error-modal/enquiry-error-modal.component';
import { CarouselNavigationButtonComponent } from '@shared/buttons/carousel-navigation-button/carousel-navigation-button.component';

@NgModule({
	declarations: [
		HeaderComponent,
		LoaderComponent,
		ErrorModalComponent,
		EnquiryErrorModalComponent,
		ToTopBtnComponent,
		LeaveModalComponent,
		DeleteModalComponent,
		RetailerSuccessModalComponent,
		RetailerNoSelectModalComponent,
		RetailerSelectModalComponent,
		SelectBackgroundModalComponent,
		SaveWorkModalComponent,
		RotateDeviceModalComponent,
		ArLoadingModalComponent,
		QuizModalComponent,
		RetailerInfoModalComponent,
		RetailerInfoPopoverComponent,
		AugmentedRealityComponent,
		FeedbackFormComponent,
		SaveWorkEmailModalComponent,
		DisabledLinkModalComponent,
		TaskbarComponent,
		ArNoBlindsModalComponent,
		AnotherDeviceModalComponent,
		LinkUnavailableModalComponent,
		CountrySelectorComponent,
		ConfirmModalComponent,
		ChangeBackgroundImageModalComponent,
		PayDepositModalComponent,
		DepositSuccessModalComponent,
		VerifyEmailModalComponent,
		QuotationMobileModalComponent,
		MessageBoxComponent,
		OrderPlacedModalComponent,
	],
	imports: [
		CommonModule,
		AppRoutingModule,
		TranslateModule,
		SlickCarouselModule,
		ReactiveFormsModule,
		DirectivesModule,
		MatSelectModule,
		MatFormFieldModule,
		NgbPopover,
		MatProgressBarModule,
		StripeCardComponent,
		StripeCardGroupDirective,
		StripeCardNumberComponent,
		StripeCardExpiryComponent,
		StripeCardCvcComponent,
		StripePaymentRequestButtonComponent,
		NgxStripeElementLoadingTemplateDirective,
		CoreModule,
		CarouselNavigationButtonComponent,
	],
	exports: [
		HeaderComponent,
		LoaderComponent,
		ToTopBtnComponent,
		RetailerInfoPopoverComponent,
		AugmentedRealityComponent,
		FeedbackFormComponent,
		MessageBoxComponent,
	],
})
export class SharedModule {}
